import React, {useEffect, useState} from "react";
import {Image, Button, TextInput, LoadingOverlay, Center, rem, List, ThemeIcon, Alert} from "@mantine/core";
import {useForm} from "@mantine/form";
import {useNavigate} from "react-router-dom";
import classes from "./JoinWaitlist.module.scss";
import {IconCheck, IconInfoCircle} from "@tabler/icons-react";
import {joinWaitlist} from "@fig/libs/client/api/fig/routes/waitlist";

const buttonContainerStyles = {
  display: "flex",
  justifyContent: "center",
};

interface JoinWaitlistProps {
  closeModal: () => void;
}

export const JoinWaitlist: React.FC<JoinWaitlistProps> = ({closeModal}) => {
  const navigate = useNavigate();
  useEffect(() => {
    return () => {
      //console.log('Component will unmount');
    };
  }, []);

  const form = useForm({
    initialValues: {emailAddress: ""},

    // functions will be used to validate values at corresponding key
    validate: {
      emailAddress: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const sendWaitlistEmail = async (data: {emailAddress: string}) => {
    setIsButtonDisabled(true);

    try {
      const {
        data: {waitlist},
      } = await joinWaitlist(data.emailAddress);
      navigate(`/waitlist/${waitlist.id}`);
      closeModal();
    } catch (error: any) {
      form.setErrors(error.data.errors);
    }

    // notifications.show({
    //   title: "You're on the waitlist  🎉",
    //   message: "We'll be in touch soon!",
    //   autoClose: 5000,
    //   color: "blue",
    // });
    setIsButtonDisabled(false);
    //closeModal();
  };

  return (
    <>
      <LoadingOverlay visible={isButtonDisabled} overlayProps={{radius: "sm", blur: 2}} />
      <Center>
        <Image src={"/assets/logo/fig-black.png"} height={40} mb="xs" alt={"fig logo"} />
      </Center>
      <Alert
        p={rem(15)}
        pl={rem(20)}
        fz={rem(15)}
        variant="light"
        color="blue"
        w={"100%"}
        title={<p className={classes.notif}>WE'RE CURRENTLY IN PRIVATE BETA</p>}
        icon={<IconInfoCircle />}></Alert>
      {/* {
        <List
          className={classes.bullets}
          mt={30}
          spacing="sm"
          size="sm"
          icon={
            <ThemeIcon size={20} radius="xl">
              <IconCheck style={{width: rem(12), height: rem(12)}} stroke={1.5} />
            </ThemeIcon>
          }>
          {[
            <span key={1}>
              <b>Tax Savings</b> - Automate your tax savings and payments
            </span>,
            <span key={2}>
              <b>Expense Management</b> - Keep track of all of your business expenses
            </span>,
            <span key={3}>
              <b>Income Tracking</b> - Gain a clear view into your income
            </span>,
            <span key={4}>
              <b>Retirement Plans</b> - Find pre-tax deductions and contribute to your IRA or Solo401k
            </span>,
            <span key={5}>
              <b>HSA</b> - Take advantage of pre-tax deducations with your HSA
            </span>,
            <span key={6}>
              <b>Financial Advisors</b> - Chat with financial advisors who can help you plan for the future
            </span>,
          ].map((bullet, index) => (
            <List.Item key={index}>{bullet}</List.Item>
          ))}
        </List>
      } */}

      <p className={classes.graf}>
        {" "}
        We are rolling out access to Fig in cohorts. Let us know how we can reach you to kick-off your financial
        journey.
      </p>
      <form onSubmit={form.onSubmit(sendWaitlistEmail)}>
        <TextInput
          mt="sm"
          label="Email"
          type="email"
          autoComplete={"email"}
          placeholder="your@email.com"
          {...form.getInputProps("emailAddress")}
        />
        <div style={buttonContainerStyles}>
          <Button
            type="submit"
            fz={rem(14)}
            fw={500}
            mt="sm"
            color="black"
            radius="xl"
            size="md"
            disabled={isButtonDisabled}>
            Join the Waitlist
          </Button>
        </div>
      </form>
    </>
  );
};
